import { useMediaQuery } from '../PDFFormatter/mediaSize'
import { amtStr, numberFormatter } from '../StringNumberFunction/numFormatter'

export const useNumberFormatter = () => {
  const [width] = useMediaQuery() /// hooks monitor browser window width

  const amountFormatter = (value: any) => {
    let amount: string = '0.00'

    if (width < 600) {
      amount = numberFormatter(value)
    } else {
      // NOTE: TO BE UNCOMMENTED
      // THIS REQUIRES A FULL IMPLEMENTATION PENDING FOR ADLIN TO ASSIST
      amount = amtStr(value)
      // amount = numberFormatter(value)
    }
    return amount
  }

  return { amountFormatter }
}
